import Vue from 'vue';
import store from '@/store';
import ProcessNames from '@/process/names.js';

import StubComponent from '@/components/Stub.vue';

import ResponseList from '@/components/responses/List.vue';
import BatPAResponseList from '@/process/bat-personal-account/components/responses/List.vue';

// tabs
import DefaultResponseTabsTabTest from '@/routes_new/inner/candidate/test/default/index.vue';

// import ShlumbergerResponseTabsTabTest from '@/process/shlumberger/components/response/tabs/tabTest/Scene.vue';
import ShlumbergerResponseTabsTabTest from '@/routes_new/inner/candidate/test/shlumberger/index.vue';
import ShlumbergerResponseTabsTabResume from '@/process/shlumberger/components/response/tabs/TabResume.vue';
import BatChampionshipResponseTabsTabTeam from '@/process/bat-championship/components/response/tabs/TabTeam.vue';
import QuestionnaireLandingResponseTabsTabQuestionnaire from '@/process/questionnaire-landing/components/response/tabs/TabQuestionnaire.vue';
import BcgResponseTabsTabTest from '@/process/bcg-test/components/response/tabs/test/index';
import FenicheResponseTabsTabTest from '@/process/feniche/common/components/response/tabs/test/index';
import JtiMakeItBrightStageTwoResponseTabsTabPresentation from '@/process/jti-make-it-bright/stage-two/components/response/tabs/presentation-tab/index.vue';
// --

import ResponseFilterPanelAdditional from '@/components/responses/FilterPanelAdditional.vue';
import ShlumbergerResponseFilterPanelAdditional from '@/process/shlumberger/components/responses/FilterPanelAdditional.vue';

import VacancyNavigation from '@/components/vacancy/Navigation.vue';
import ShlumbergerVacancyNavigation from '@/process/shlumberger/components/vacancy/Navigation.vue';

import InterviewTestContainer from '@/components/interview/test/Container.vue';
import ShlumbergerInterviewTestContainer from '@/process/shlumberger/components/interview/test/Container.vue';

import ResponseVideointerviewSceneProcess from '@/components/response/videointerview/SceneProcess.vue';
// import BatChampionshipResponseVideointerviewSceneProcess from '@/process/bat-championship/components/response/videointerview/SceneProcess.vue';
import BatChampionshipResponseVideointerviewSceneProcess from '@/process/bat-championship/components/response/videointerview/SceneProcess.vue';

// import ResponseSceneProcess from '@/components/response/SceneProcess.vue';
// import BatChampionshipResponseSceneProcess from '@/process/bat-championship/components/response/SceneProcess.vue';
// import BatPersonalAccountResponseSceneProcess from '@/process/bat-personal-account/components/response/SceneProcess.vue';
// import CitibankResponseSceneProcess from '@/process/citibank/components/response/SceneProcess.vue';

import ResponsesRow from '@/components/responses/RowProcess.vue';
import BatChampionshipResponsesRow from '@/process/bat-championship/components/responses/RowProcess.vue';
import CitibankResponsesRow from '@/process/citibank/components/responses/RowProcess.vue';

import ResponseBlocksBlockContacts from '@/components/response/blocks/BlockContactsIndex.vue';
import BatChampionshipResponseBlocksBlockContacts from '@/process/bat-championship/components/response/blocks/BlockContacts.vue';
import CitibankResponseBlocksBlockContacts from '@/process/citibank/components/response/blocks/BlockContacts.vue';

import ResponseResumeAdditionalInfo from '@/components/response/resume/ResumeAdditionalInfoProcess.vue';
import BatPersonalAccountResponseResumeAdditionalInfo from '@/process/bat-personal-account/components/response/resume/ResumeAdditionalInfoProcess.vue';

import VacancyPreferencesSpecial from '@/components/vacancy/preferences/SpecialProcess.vue';
import BatPAVacancyPreferencesSpecial from '@/process/bat-personal-account/components/vacancy/preferences/SpecialProcess.vue';
import CitibankVacancyPreferencesSpecial from '@/process/citibank/components/vacancy/preferences/SpecialProcess.vue';
import DeloitteSFVacancyPreferencesSpecial from '@/process/deloitte-sf/components/vacancy/preferences/SpecialProcess.vue';

// response
import ApiResponse from '@/api/response.js';
import BatPAApiResponse from '@/process/bat-personal-account/api/response.js';
import BatChampionshipApiResponse from '@/process/bat-championship/api/response.js';
import CitibankApiResponse from '@/process/citibank/api/response.js';
import ShlumbergerApiResponse from '@/process/shlumberger/api/response.js';
import SiburStajirovkiApiResponse from '@/process/sibur-stajirovki/api/response.js';
import BkManagerApiResponse from '@/process/bk-manager/api/response.js';
// --

// interview
import InterviewSceneProcess from '@/components/interview/SceneProcess.vue';
import ShlumbergerInterviewSceneProcess from '@/process/shlumberger/components/interview/SceneProcess.vue';

import InterviewVideointerviewSceneProcess from '@/components/interview/videointerview/SceneProcess.vue';
import ShlumbergerInterviewVideointerviewSceneProcess from '@/process/shlumberger/components/interview/videointerview/SceneProcess.vue';
// --

// vacancy
import VacancyPreferencesSceneProcess from '@/components/vacancy/preferences/SceneProcess.vue';
import CitibankVacancyPreferencesSceneProcess from '@/process/citibank/components/vacancy/preferences/SceneProcess.vue';
import DeloitteSFVacancyPreferencesSceneProcess from '@/process/deloitte-sf/components/vacancy/preferences/SceneProcess.vue';
// --

// invite
import InviteCreationProcessRowHeader from '@/components/invites/creation/ProcessRowHeader.vue';
import CitibankInviteCreationProcessRowHeader from '@/process/citibank/components/invites/creation/ProcessRowHeader.vue';

// import InviteCreationProcessRowEditable from '@/components/invites/creation/ProcessRowEditable.vue';
// import CitibankInviteCreationProcessRowEditable from '@/process/citibank/components/invites/creation/ProcessRowEditable.vue';

import InviteProcessRow from '@/components/invites/ProcessRow.vue';
import CitibankInviteProcessRow from '@/process/citibank/components/invites/ProcessRow.vue';

import ApiInvite from '@/api/invite.js';
// import CitibankApiInvite from '@/process/citibank/api/invite.js';
// --

function injectProductDependencies () {
  store.dispatch('situation/response/setTabsAvailable', {tabsAvailable: store.getters['response/tabs/tabsAvailable']})
  store.dispatch('situation/vacancy/preferences/setRoutesList', {routesList: store.getters['vacancy/preferences/getRoutesList']})
  store.dispatch('situation/api/setInvitesAPI', ApiInvite)
  store.dispatch('situation/api/setResponseAPI', ApiResponse)

  Vue.component('process-response-list', ResponseList)
  Vue.component('process-responses-filter-panel-additional', ResponseFilterPanelAdditional)
  Vue.component('process-vacancies-navigation', VacancyNavigation)
  Vue.component('process-interview-test-container', InterviewTestContainer)
  Vue.component('process-response-videointerview-scene', ResponseVideointerviewSceneProcess)
  Vue.component('process-responses-row', ResponsesRow)
  // Vue.component('process-response-scene', ResponseSceneProcess)
  Vue.component('process-response-blocks-block-contacts', ResponseBlocksBlockContacts)
  Vue.component('process-response-resume-additional-info', ResponseResumeAdditionalInfo)
  Vue.component('process-vacancy-preferences-special', VacancyPreferencesSpecial)

  // tabs
  Vue.component('process-response-tab-test', DefaultResponseTabsTabTest)
  Vue.component('process-response-tab-resume', StubComponent)
  Vue.component('process-response-tab-team', StubComponent)
  Vue.component('process-response-tab-questionnaire', StubComponent)
  Vue.component('process-response-tab-presentation', StubComponent)
  // --

  // interview
  Vue.component('process-interview-scene', InterviewSceneProcess)
  Vue.component('process-interview-videointerview-scene', InterviewVideointerviewSceneProcess)
  // --

  // vacancy
  Vue.component('process-vacancy-preferences-scene', VacancyPreferencesSceneProcess)
  // --

  // invite
  Vue.component('process-invites-creation-row-header', InviteCreationProcessRowHeader)
  // Vue.component('process-invites-creation-row-editable', InviteCreationProcessRowEditable)
  Vue.component('process-invites-row', InviteProcessRow)
  // --
}

function injectBatPADependencies () {
  store.dispatch('situation/vacancy/preferences/setRoutesList', {routesList: store.getters['process/batPersonalAccount/vacancy/preferences/getRoutesList']})
  store.dispatch('situation/api/setResponseAPI', Object.assign({}, ApiResponse, BatPAApiResponse))

  Vue.component('process-response-list', BatPAResponseList)
  Vue.component('process-vacancy-preferences-special', BatPAVacancyPreferencesSpecial)
  // Vue.component('process-response-scene', BatPersonalAccountResponseSceneProcess)
  Vue.component('process-response-resume-additional-info', BatPersonalAccountResponseResumeAdditionalInfo)
}

function injectBatChanpioshipDependencies () {
  store.dispatch('situation/response/setTabsAvailable', {tabsAvailable: store.getters['process/batChampionship/response/tabs/tabsAvailable']})
  store.dispatch('situation/api/setResponseAPI', Object.assign({}, ApiResponse, BatChampionshipApiResponse))

  Vue.component('process-response-videointerview-scene', BatChampionshipResponseVideointerviewSceneProcess)
  Vue.component('process-responses-row', BatChampionshipResponsesRow)
  // Vue.component('process-response-scene', BatChampionshipResponseSceneProcess)
  Vue.component('process-response-blocks-block-contacts', BatChampionshipResponseBlocksBlockContacts)
  Vue.component('process-response-tab-team', BatChampionshipResponseTabsTabTeam)
}

function injectShlumbergerDependencies () {
  store.dispatch('situation/response/setTabsAvailable', {tabsAvailable: store.getters['process/shlumberger/response/tabs/tabsAvailable']})
  store.dispatch('situation/api/setResponseAPI', Object.assign({}, ApiResponse, ShlumbergerApiResponse))

  Vue.component('process-responses-filter-panel-additional', ShlumbergerResponseFilterPanelAdditional)
  Vue.component('process-vacancies-navigation', ShlumbergerVacancyNavigation)
  Vue.component('process-interview-test-container', ShlumbergerInterviewTestContainer)
  Vue.component('process-response-tab-test', ShlumbergerResponseTabsTabTest)
  Vue.component('process-response-tab-resume', ShlumbergerResponseTabsTabResume)
  Vue.component('process-interview-scene', ShlumbergerInterviewSceneProcess)
  Vue.component('process-interview-videointerview-scene', ShlumbergerInterviewVideointerviewSceneProcess)
  // Vue.component('process-responses-scene', ShlumbergerResponsesSceneProcess)
}

function injectQuestionnaireLandingDependencies () {
  store.dispatch('situation/response/setTabsAvailable', {tabsAvailable: store.getters['process/questionnaireLanding/response/tabs/tabsAvailable']})

  Vue.component('process-response-tab-questionnaire', QuestionnaireLandingResponseTabsTabQuestionnaire)
}

function injectCitibankDependencies() {
  store.dispatch('situation/vacancy/preferences/setRoutesList', {
    routesList: store.getters['process/citibank/vacancy/preferences/getRoutesList']
  });
  // store.dispatch('situation/api/setInvitesAPI', Object.assign({}, ApiInvite, CitibankApiInvite))
  store.dispatch('situation/api/setResponseAPI', Object.assign({}, ApiResponse, CitibankApiResponse));

  // responses
  Vue.component('process-responses-row', CitibankResponsesRow);
  // Vue.component('process-response-scene', CitibankResponseSceneProcess)
  Vue.component('process-response-blocks-block-contacts', CitibankResponseBlocksBlockContacts);
  // --

  // vacancy
  Vue.component('process-vacancy-preferences-special', CitibankVacancyPreferencesSpecial)
  Vue.component('process-vacancy-preferences-scene', CitibankVacancyPreferencesSceneProcess)
  // --

  // invite
  Vue.component('process-invites-creation-row-header', CitibankInviteCreationProcessRowHeader)
  // Vue.component('process-invites-creation-row-editable', CitibankInviteCreationProcessRowEditable)
  Vue.component('process-invites-row', CitibankInviteProcessRow)
  // --
}

function injectDeloitteSFDependencies () {
  store.dispatch(
    'situation/vacancy/preferences/setRoutesList',
    {
      routesList: store.getters['process/deloitteSF/vacancy/preferences/getRoutesList']
    }
  )

  // vacancy
  Vue.component('process-vacancy-preferences-special', DeloitteSFVacancyPreferencesSpecial)
  Vue.component('process-vacancy-preferences-scene', DeloitteSFVacancyPreferencesSceneProcess)
  // --
}

function injectJtiMakeItBrightStageTwoDependencies () {
  store.dispatch('situation/response/setTabsAvailable', {tabsAvailable: [{name: 'presentation'}].concat(store.getters['response/tabs/tabsAvailable'])});
  // response
  Vue.component('process-response-tab-presentation', JtiMakeItBrightStageTwoResponseTabsTabPresentation);
}

function injectBcgTestDependencies () {
  store.dispatch('situation/response/setTabsAvailable', {tabsAvailable: [{name: 'test-specprocess'}].concat(store.getters['response/tabs/tabsAvailable'])});
  // response
  Vue.component('process-response-tab-test', BcgResponseTabsTabTest);
}

function injectSiburInternshipDependencies () {
  store.dispatch('situation/api/setResponseAPI', Object.assign({}, ApiResponse, SiburStajirovkiApiResponse))
}

function injectFenicheDependencies () {
  store.dispatch('situation/response/setTabsAvailable', {tabsAvailable: [{name: 'test-specprocess'}].concat(store.getters['response/tabs/tabsAvailable'])});
  // response
  Vue.component('process-response-tab-test', FenicheResponseTabsTabTest);
}

function injectBkManagerDependencies () {
  store.dispatch('situation/api/setResponseAPI', Object.assign({}, ApiResponse, BkManagerApiResponse))
}

// injection function, which set global process components depends on current special process condition
export default () => {
  // special process value
  const activeProcess = store.getters['process/getName']

  // default dependencies
  injectProductDependencies()

  switch (activeProcess) {
    // bat dependency
    case ProcessNames.BAT_PERSONAL_ACCOUNT:
      injectBatPADependencies()
      break
    // bat chanpionship dependencies
    case ProcessNames.BAT_CHAMPIONSHIP:
      injectBatChanpioshipDependencies()
      break
    // shlumberger dependencies
    case ProcessNames.SCHLUMBERGER:
      injectShlumbergerDependencies()
      break
    case ProcessNames.QUESTIONNAIRE_LANDING:
      injectQuestionnaireLandingDependencies()
      break
    case ProcessNames.CITIBANK: {
      injectCitibankDependencies()
      break
    }
    case ProcessNames.DELOITTE_SF: {
      injectDeloitteSFDependencies()
      break
    }
    case ProcessNames.JTI_MAKE_IT_BRIGHT_STAGE_TWO: {
      injectJtiMakeItBrightStageTwoDependencies();
      break;
    }
    case ProcessNames.BCG_TEST: {
      injectBcgTestDependencies();
      break;
    }
    case ProcessNames.SIBUR_INTERNSHIPS: {
      injectSiburInternshipDependencies();
      break;
    }
    case ProcessNames.FENICHE: {
      injectFenicheDependencies();
      break;
    }
    case ProcessNames.BK_MANAGER: {
      injectBkManagerDependencies();
      break;
    }
  }
}
